import { render, staticRenderFns } from "./ChatBoxButtonQuikReply.vue?vue&type=template&id=09dad022&scoped=true&"
import script from "./ChatBoxButtonQuikReply.vue?vue&type=script&lang=js&"
export * from "./ChatBoxButtonQuikReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxButtonQuikReply.vue?vue&type=style&index=0&id=09dad022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dad022",
  null
  
)

export default component.exports